//
// This file is AUTO-GENERATED by protoc-gen-ts.
// Do not modify it manually.
///
import api from '../../api'
import * as googleTypes from '../../googleTypes'

// File: cd-robot/v1/cd_robot.proto
// Package: arangodb.cloud.internal.cdrobot.v1

// Request for AbortRun.
export interface AbortRunRequest {
}

// RunAudit is a snapshot of one CD run (in progress or completed).
export interface RunAudit {
  // Unique id for this run (UUID).
  // string
  run_id?: string;
  
  // RunKind
  run_kind?: RunKind;
  
  // googleTypes.Timestamp
  started_at?: googleTypes.Timestamp;
  
  // Empty while the run is still in progress.
  // googleTypes.Timestamp
  ended_at?: googleTypes.Timestamp;
  
  // RunOutcome
  outcome?: RunOutcome;
  
  // IAM user who started a manual run; empty for scheduled runs.
  // string
  started_by_id?: string;
  
  // Email of starter, or "scheduler" for scheduled runs.
  // string
  started_by_email?: string;
  
  // Set when the run was manually aborted.
  // string
  aborted_by_id?: string;
  
  // string
  aborted_by_email?: string;
  
  // Flux branch used during the run.
  // string
  branch?: string;
  
  // Manual start mode (if any).
  // string
  mode?: string;
  
  // Short failure message; empty on success or abort.
  // string
  failure_summary?: string;
}

// Schedule holds cron schedule configuration for the CD robot.
// All cron expressions use standard 5-field UTC syntax.
// Stored in a cluster-local ConfigMap; not tied to deployment environment.
export interface Schedule {
  // The time the CD run will start.
  // string
  start_schedule?: string;
  
  // The time the CD run should begin stopping.
  // string
  stop_schedule?: string;
  
  // The time the CD run should be fully stopped.
  // string
  stopped_schedule?: string;
  
  // If set, CD runs will be executed on Friday and Saturday as well.
  // boolean
  run_in_weekends?: boolean;
  
  // How long before nightly start to run merge and API-compat pre-flight checks.
  // Go duration string (e.g. "8h", "30m"). Empty means the service default (8h).
  // string
  preflight_lead_time?: string;
}

// ScheduleChangeAudit records the most recent SetSchedule call.
export interface ScheduleChangeAudit {
  // googleTypes.Timestamp
  changed_at?: googleTypes.Timestamp;
  
  // string
  changed_by_id?: string;
  
  // string
  changed_by_email?: string;
  
  // Schedule
  previous_schedule?: Schedule;
  
  // Schedule
  new_schedule?: Schedule;
}

// Request for SetSchedule.
export interface SetScheduleRequest {
  // Schedule
  schedule?: Schedule;
}

// Request for StartRun.
export interface StartRunRequest {
  // If set, create a new QA branch from staging and switch Flux before starting the run.
  // If not set, start the run on the current Flux branch without creating a branch or switching Flux.
  // boolean
  create_new_qa_branch?: boolean;
  
  // Optional run mode. Reserved for future use (e.g. parallel execution strategies).
  // If empty, the default mode is used.
  // string
  mode?: string;
}

// Status describes the current state of the CD robot.
export interface Status {
  // Top-level state. Allowed values are: Waiting, Running, Stopping.
  // string
  state?: string;
  
  // Sub-state while in Running state (if any).
  // string
  running_state?: string;
  
  // Sub-state while in Stopping state (if any).
  // string
  stopping_state?: string;
  
  // Sub-state while running integration tests (if any).
  // string
  running_test_state?: string;
  
  // The branch currently configured in Flux for the controlplane GitRepository.
  // string
  flux_branch?: string;
  
  // The last error reported by the CD robot (if any).
  // string
  last_error?: string;
  
  // If set, a new CD run can be started.
  // boolean
  can_start?: boolean;
  
  // If set, the current CD run can be aborted.
  // boolean
  can_abort?: boolean;
  
  // The current schedule configuration.
  // Schedule
  schedule?: Schedule;
  
  // When the last error was recorded (if any).
  // googleTypes.Timestamp
  last_error_time?: googleTypes.Timestamp;
  
  // Whether the current or most recent run was scheduled or manual.
  // RunKind
  run_kind?: RunKind;
  
  // In-progress run audit (empty when idle).
  // RunAudit
  current_run?: RunAudit;
  
  // Most recently completed run.
  // RunAudit
  last_run?: RunAudit;
  
  // Most recent schedule change.
  // ScheduleChangeAudit
  last_schedule_change?: ScheduleChangeAudit;
}

// RunKind distinguishes scheduled (nightly) runs from manual runs
export enum RunKind {
  RUN_KIND_UNSPECIFIED = 0,
  
  // Cron-triggered nightly / scheduled window run.
  RUN_KIND_SCHEDULED = 1,
  
  // Manually started via StartRun.
  RUN_KIND_MANUAL = 2,
}

// RunOutcome is the final result of a completed CD run.
export enum RunOutcome {
  RUN_OUTCOME_UNSPECIFIED = 0,
  
  RUN_OUTCOME_SUCCESS = 1,
  
  RUN_OUTCOME_FAILED = 2,
  
  RUN_OUTCOME_ABORTED = 3,
}

// InternalCDRobotService is the API used to manage the continuous delivery robot.
export interface IInternalCDRobotService {
}

// InternalCDRobotService is the API used to manage the continuous delivery robot.
export class InternalCDRobotService implements IInternalCDRobotService {
}
